import PagedElements from '@/models/paged/pagedelements';
import ItemPropositionLinkListViewModel from '@/models/view/itempropositionlinklistviewmodel';

export default class PagedItemPropositionLinks extends PagedElements<ItemPropositionLinkListViewModel> {
    constructor(init?: Partial<PagedItemPropositionLinks>) {
        super(init);
    }
}
